export class PaginatedResultDto<T> {
  private _totalItems: number
  private _currentPage: number
  private _totalPages: number
  private _items: T[]

  constructor (totalItems: number, currentPage: number, totalPages: number, items: T[]) {
    this._totalItems = totalItems
    this._currentPage = currentPage
    this._totalPages = totalPages
    this._items = items
  }

  get totalItemCount (): number {
    return this._totalItems
  }

  get currentPage (): number {
    return this._currentPage
  }

  get totalPages (): number {
    return this._totalPages
  }

  get items (): T[] {
    return this._items
  }
}
